<template>
	<div>
		<div
		 class="sex-info"
		 :class="{'item-error': isError}"
		>
			<a
			 v-show="selectedMale || selectedFemale"
			 class="user-sex-tit"
			>性别</a>
			<div
			 class="sex-item"
			 :class="{selected: selectedMale, hidden: selectedFemale}"
			 @click="sexSelect(false)"
			>
				<a class="user-sex male"></a>
			</div>
			<div
			 class="sex-item"
			 :class="{selected: selectedFemale, hidden: selectedMale}"
			 @click="sexSelect(true)"
			>
				<a class="user-sex female"></a>
			</div>
		</div>
	</div>
</template>
<script>
import * as types from "../../../store/mutation-types";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			selectedMale: false,
			selectedFemale: false,
			isError: false,
			isFirst: true
		};
	},
	computed: {
		...mapGetters(["gender", "pagetypeLog"])
	},
	watch: {
		gender(val) {
			if (this.isFirst) {
				this.sexSelect(val);
				this.isFirst = false;
			}
		}
	},
	created() {
		if (this.isFirst && this.gender !== "") {
			this.sexSelect(this.gender);
			this.isFirst = false;
		}
	},
	methods: {
		sexSelect(val) {
			window.clickLog &&
				window.clickLog("from=jl_sexclk" + this.pagetypeLog);
			if (this.selectedMale === true || this.selectedFemale === true) {
				// 解决当初始化为空，点击第一次无反应情况bug
				if (this.isFirst) {
					return;
				}
				this.selectedMale = false;
				this.selectedFemale = false;
				this.$store.commit(types.CHECK_BASICINFO, {
					key: "gender",
					value: "",
					state: null
				});
			} else {
				if (val === false) {
					this.selectedMale = true;
					this.selectedFemale = false;
				} else {
					this.selectedFemale = true;
					this.selectedMale = false;
				}
				this.isError = false;
				this.$store.commit(types.CHECK_BASICINFO, {
					key: "gender",
					value: val,
					state: true
				});
			}
		},
		// 点击保存检查为空
		checkNull() {
			window.clickLog &&
				window.clickLog("from=jl_sexmiss" + this.pagetypeLog);
			this.isError = true;
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.user-sex-tit {
	display: block;
	font-size: px2rem(24px);
	color: #cccccc;
	letter-spacing: 0;
	line-height: px2rem(36px);
	margin: px2rem(-10px) auto 0;
}
.sex-item {
	width: px2rem(120px);
	height: px2rem(60px);
	display: inline-block;
	padding: px2rem(12px) px2rem(15px);
	box-sizing: content-box;
}
.selected {
	margin: px2rem(-10px) auto;
}
.user-sex {
	display: inline-block;
	border: 1px solid #e3e3e4;
	border-radius: 3.6rem;
	width: px2rem(120px);
	height: px2rem(60px);
	font-size: px2rem(24px);
	line-height: px2rem(60px);
	color: #999;
}
.male {
	border: none;
	background: url(//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/ic_male@2x.png)
		no-repeat;
	background-size: contain;
}
.female {
	border: none;
	background: url(//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/ic_female@2x.png)
		no-repeat;
	background-size: contain;
}
</style>



// WEBPACK FOOTER //
// index.vue?72beaf02